var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import * as PropTypes from "prop-types";
import moment from "moment";
import Loading from "@irati/ui/src/Loading";
import OnboardingStep from "@irati/onboarding/enums/Step";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import authentication from "@irati/auth";
import OnboardingService from "@irati/onboarding/services/onboarding";
import { hangPromise } from "@irati/utils/promise";
import tenantSetupTracking, { ExitSetupButtonValues } from "@irati-tracking/tenant-setup";
import { PostSetupTooltip, ChecklistSetupTooltip } from "@irati-web/tenantsetup/src/components/HeaderTooltips";
import { getCurrentTenantSetupStepConfig } from "@irati-web/tenantsetup/src/helpers";
import { HeaderButtonStyle, AbsoluteWrapper } from "../styled";
var LEGACY_POST_TENANT_SETUP_HIDE_COOKIE = "hideTenantSetupPostPrompt";
var CHECKLIST_TENANT_HIDE_COOKIE = "hideTenantSetupChecklist";
var DesktopHeaderButton = /** @class */ (function (_super) {
    __extends(DesktopHeaderButton, _super);
    function DesktopHeaderButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showTenantOnboarding: false,
            showPostSetupTooltip: false,
            showChecklistSetupTooltip: false,
            load: hangPromise(),
            buttonLabel: "",
            buttonLink: ""
        };
        _this._isMounted = false;
        _this.getTodaysDate = function () { return moment().format("DDMMYYYY"); };
        _this.handlePostSetupTooltipClose = function () {
            _this.setState({ showPostSetupTooltip: false });
            _this.neverShowPostSetupTooltipAgain();
        };
        _this.handleChecklistSetupTooltipClose = function () {
            _this.setState({ showChecklistSetupTooltip: false });
            localStorage.setItem(CHECKLIST_TENANT_HIDE_COOKIE, _this.getTodaysDate());
        };
        _this.neverShowPostSetupTooltipAgain = function () {
            return OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_VIEWED_TENANT_SETUP_POST_TOUR);
        };
        _this.trackClick = function () {
            var onboardingSteps = _this.state.onboardingSteps;
            var formatMessage = _this.props.formatMessage;
            var _a = _this.context, appPath = _a.appPath, contextApps = _a.apps;
            var SETUP_TENANT = contextApps.SETUP_TENANT;
            var isTenantSetup = appPath === SETUP_TENANT;
            if (isTenantSetup) {
                var currentStepConfig_1 = getCurrentTenantSetupStepConfig();
                if (!currentStepConfig_1)
                    return;
                var currentStep = onboardingSteps.find(function (step) { return step.stepId === currentStepConfig_1.stepId; });
                if (currentStep) {
                    var params = {
                        step_name: formatMessage({ id: currentStepConfig_1.title }),
                        step_id: currentStep.stepId,
                        step_number: currentStepConfig_1.order,
                        option_id: currentStep.selection,
                        button: ExitSetupButtonValues.Top
                    };
                    tenantSetupTracking.exitSetup(params);
                }
            }
        };
        return _this;
    }
    DesktopHeaderButton.prototype.componentDidMount = function () {
        var _this = this;
        this._isMounted = true;
        var _a = this.context, appPath = _a.appPath, contextApps = _a.apps;
        var SETUP_TENANT = contextApps.SETUP_TENANT, ADMIN = contextApps.ADMIN, HOME = contextApps.HOME;
        var isTenantSetup = appPath === SETUP_TENANT;
        var isAdminSection = appPath === ADMIN;
        var buttonLabel = isAdminSection ? "platform.header.adminButton.exit" : "platform.header.adminButton.admin";
        var buttonLink = isAdminSection ? HOME : ADMIN;
        var isGlobalAdmin = authentication.isGlobalAdmin();
        var isUserGhost = authentication.isUserGhost();
        var isLoggedIn = authentication.isLoggedIn();
        if ((isGlobalAdmin || isUserGhost) && isLoggedIn) {
            var promises = [OnboardingService.getTenantOnboarding()];
            if (!isUserGhost) {
                promises.push(OnboardingService.get(authentication.user().uuid));
            }
            var load = Promise.all(promises)
                .then(function (_a) {
                var tenantOnboarding = _a[0], userOnboarding = _a[1];
                if (!_this._isMounted) {
                    return;
                }
                var enabled = tenantOnboarding.enabled, onboardingFinished = tenantOnboarding.onboardingFinished, onboardingSteps = tenantOnboarding.assignedSteps;
                // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
                var seenModalPreviously = userOnboarding === null || userOnboarding === void 0 ? void 0 : userOnboarding.completedSteps.includes(OnboardingStep.HAS_VIEWED_TENANT_SETUP_POST_TOUR);
                var legacyCheck = localStorage.getItem(LEGACY_POST_TENANT_SETUP_HIDE_COOKIE);
                // If the service thinks the user should see the tour but they have the LocalStorage value, fire an update
                if (!seenModalPreviously && legacyCheck) {
                    _this.neverShowPostSetupTooltipAgain();
                }
                else if (!seenModalPreviously && enabled && onboardingFinished && !isAdminSection) {
                    _this.setState({ showPostSetupTooltip: true });
                }
                var tenantSetupActive = enabled && !onboardingFinished;
                // Show checklist only once per day and only if that user has not visited the tenant setup area or dismissed tooltip
                var showChecklistSetupTooltip = false;
                if (tenantSetupActive && !isTenantSetup && !(localStorage.getItem(CHECKLIST_TENANT_HIDE_COOKIE) === _this.getTodaysDate())) {
                    showChecklistSetupTooltip = true;
                }
                if (isTenantSetup)
                    _this.handleChecklistSetupTooltipClose();
                if (tenantSetupActive) {
                    buttonLabel = isTenantSetup ? "platform.header.adminButton.setupTenantExit" : "platform.header.adminButton.setupTenantStart";
                    buttonLink = isTenantSetup ? HOME : SETUP_TENANT;
                }
                _this.setState({ showTenantOnboarding: tenantSetupActive, showChecklistSetupTooltip: showChecklistSetupTooltip, onboardingSteps: onboardingSteps, buttonLabel: buttonLabel, buttonLink: buttonLink });
            })
                .catch(function () {
                _this.setState({ showTenantOnboarding: false, buttonLabel: buttonLabel, buttonLink: buttonLink });
            });
            this.setState({ load: load });
        }
        else {
            // if user is manager (hasAdminAccess) promise resolved to show label
            // (as they can see admin button to manage teams, etc...)
            this.setState({ load: Promise.resolve(), buttonLabel: buttonLabel, buttonLink: buttonLink });
        }
    };
    DesktopHeaderButton.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    DesktopHeaderButton.prototype.render = function () {
        var _a = this.state, showPostSetupTooltip = _a.showPostSetupTooltip, showChecklistSetupTooltip = _a.showChecklistSetupTooltip, load = _a.load, onboardingSteps = _a.onboardingSteps, buttonLabel = _a.buttonLabel, buttonLink = _a.buttonLink;
        var _b = this.context, appPath = _b.appPath, contextApps = _b.apps;
        var SETUP_TENANT = contextApps.SETUP_TENANT;
        var isTenantSetup = appPath === SETUP_TENANT;
        var isLoggedIn = authentication.isLoggedIn();
        var hasAdminAccess = authentication.hasAdminAccess();
        if (!isLoggedIn || !hasAdminAccess)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement(HeaderButtonStyle, { to: "/", app: buttonLink, onClick: this.trackClick, id: "platform_header_button_toggleAdmin" },
                React.createElement(Loading, { useLoader: false, load: load }, buttonLabel && React.createElement(FormattedMessage, { id: buttonLabel }))),
            React.createElement(AbsoluteWrapper, null,
                React.createElement(Loading, { useLoader: false, load: load },
                    showPostSetupTooltip && !isTenantSetup && React.createElement(PostSetupTooltip, { handleClose: this.handlePostSetupTooltipClose }),
                    showChecklistSetupTooltip && onboardingSteps && (React.createElement(ChecklistSetupTooltip, { steps: onboardingSteps, handleClose: this.handleChecklistSetupTooltipClose }))))));
    };
    DesktopHeaderButton.contextTypes = {
        apps: PropTypes.object.isRequired,
        appPath: PropTypes.string.isRequired
    };
    return DesktopHeaderButton;
}(Component));
export default injectIntl(DesktopHeaderButton);
